import React from 'react';

export const SpinnerLoader = () => <div className="spinnerFile" />;
